function Test() {
  return (
    <div>
      <div className='flex-2 flex-3 bg-secondary-l bg-contrast-l -mb-1 border-main border-main-d border-main-l border-primary border-pirmary-d border-primary-l border-contrast border-contrast-d border-contrast-l border-secondary border-secondary-d border-secondary-l from-primary-d from-primary-d/50 from-primary-d/25 from-primary-l from-primary-l/50 from-primary-l/25 from-main from-contrast from-secondary from-secondary/50 from-secondary/25'></div>
      Home
      <div
        class={`
      from-red from-orange from-yellow from-lime from-green from-blue from-purple from-pink
      from-red/50 from-orange/50 from-yellow/50 from-lime/50 from-green/50 from-blue/50 from-purple/50 from-pink/50
      from-red/25 from-orange/25 from-yellow/25 from-lime/25 from-green/25 from-blue/25 from-purple/25 from-pink/25
      
        `}
      ></div>
      <div className='w-1/6 w-1/12 bg-secondary bg-main-d flex-2 bg-primary-l p-03 -ml-03'></div>
      <div className='bg-main text-contrast'>
        <div className='border-primary border-l ml-1'>
          <div className='flex items-center gap-1'>
            <div className='bg-primary-l p-03 -ml-03 rounded-full'></div>0 - Fin
            de l'Âge Noir
          </div>
          <div className='flex items-center gap-1'>
            <div className='bg-primary-l p-03 -ml-03 rounded-full'></div>227 -
            Arrivé des changelins sur Antrare
          </div>
          <div className='flex items-center gap-1'>
            <div className='bg-primary-l p-03 -ml-03 rounded-full'></div>276 -
            Création de l'Inquisition
          </div>
        </div>
      </div>
      <div className='bg-red bg-orange bg-yellow bg-lime bg-green bg-blue bg-purple bg-pink     border-red border-orange border-yellow border-lime border-green border-blue border-purple border-pink'></div>
      <div className='object-center mr-2 ml-2 mb-2 h-0.5 h-1 h-1.5 h-2 h-3 h-8 h-20 h-22 h-28 h-32 h-40 h-60 w-0.5 w-1 w-1.5 w-2 w-3 w-8 w-20 w-22 w-28 w-32 w-40 w-60 rounded-full float-right md:float-right float-left md:float-left sm:float-none object-none hover:object-none hover:object-right hover:object-right-bottom' />
      <div className='-mt-1 -mt-3 -mt-4 -mt-5 -mt-6 -mt-7 -mt-8 -mt-9 bg-gradient-to-r from-primary to-secondary bg-gradient-to-l from-secondary to-primary font-special text-3xl text-4xl text-5xl  text-6xl text-7xl text-8xl text-9xl' />
    </div>
  );
}

export default Test;
